/* eslint-disable max-len */
export const deals = {
  data: {
    '646448397996bbe2b288426b': [
      {
        _id: '6603d732ec6060359d14cd1e',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: [],
        leadId: [],
        companyId: null,
        name: 'Deal 2',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 1,
        createdAt: '2024-03-27T08:22:10.783Z',
        updatedAt: '2024-03-27T08:22:10.783Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 2000,
        stageId: '646448397996bbe2b288426b',
        _amount: '2,000.00',
      },
      {
        _id: '65d315412aa5ac23af320c6a',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['64fa831d6c9a7d29383bac1d'],
        leadId: [
          {
            _id: '65c9b5fe43c1c50af7cd09d1',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'John',
            lastName: 'Ardosa',
            fullName: 'John Ardosa',
            emailAddress: 'jardosa+feb_12@leapify.com',
            mobileNumber: null,
          },
        ],
        companyId: {
          _id: '65c9d09643c1c50af7cd0efa',
          name: 'Clean Energy Ventures',
          accountId: '63e05fe4d59adc087e305e08',
          industry: 'aerospace',
          type: 'jointVenture',
          createdAt: '2024-02-12T08:02:30.153Z',
          updatedAt: '2024-02-12T08:02:30.153Z',
          trashed: false,
          trashedAt: null,
          __v: 0,
          id: '65c9d09643c1c50af7cd0efa',
        },
        name: 'Deal 4',
        type: 'NEW_BUSINESS',
        closedAt: '2024-02-12T16:00:00.000Z',
        sequence: 1,
        createdAt: '2024-02-19T08:45:53.283Z',
        updatedAt: '2024-03-21T08:10:36.987Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 43241,
        stageId: '646448397996bbe2b288426b',
        _amount: '43,241.00',
      },
    ],
    '646441abd973766a4dd62f28': [
      {
        _id: '65b0bf64c05b317b48e02b9a',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: [],
        leadId: [],
        companyId: null,
        name: 'Deal 5',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 1,
        createdAt: '2024-01-24T07:42:28.132Z',
        updatedAt: '2024-01-24T08:08:50.520Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 5000,
        stageId: '646441abd973766a4dd62f28',
        _amount: '5,000.00',
      },
    ],
    '64f94a605b1334b16062f3fd': [
      {
        _id: '64f944875b1334b16062ee73',
        pipelineId: '6464375a74df66748857a3d7',
        accountId: '63e05fe4d59adc087e305e08',
        accountUserId: ['63bf972ac560036d9e42b3f6'],
        leadId: [
          {
            _id: '63b62efbcef33a72b438ce8b',
            accountId: '63e05fe4d59adc087e305e08',
            firstName: 'Johns',
            lastName: 'Ardosas',
            emailAddress: 'johnArdosa@tacobell.nets',
            mobileNumber: '+639176475551',
            companyId: null,
            fullName: 'Johns Ardosas',
          },
          {
            _id: '6502a83719b8404b74a535a9',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'Lead',
            lastName: 'Four',
            fullName: 'Lead Four',
            emailAddress: 'jardosa+lead_4@leadorigin.com',
            mobileNumber: '',
          },
          {
            _id: '6502a82419b8404b74a53598',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'Lead',
            lastName: 'Three',
            fullName: 'Lead Three',
            emailAddress: 'jardosa+lead_03@leadorigin.com',
            mobileNumber: '',
          },
          {
            _id: '6502a7b919b8404b74a5355e',
            accountId: '63e05fe4d59adc087e305e08',
            companyId: null,
            firstName: 'Lead',
            lastName: 'Two',
            fullName: 'Lead Two',
            emailAddress: 'jardosa+lead_02@leadorigin.com',
            mobileNumber: '',
          },
        ],
        companyId: {
          _id: '646324b6f3a89fed15a2c228',
          name: 'Deal 13',
          accountId: '63e05fe4d59adc087e305e08',
          industry: 'computer',
          type: 'corporation',
          city: 'San Francisco',
          state: 'CA',
          postalCode: '90210',
          noEmployees: 10100,
          annualRevenue: null,
          timezone: '',
          description: '',
          linkedinUrl: '',
          companyWebsite: 'www.microsoft.com',
          createdAt: '2023-05-16T06:37:42.128Z',
          updatedAt: '2024-01-23T08:34:49.748Z',
          __v: 0,
          photoUrl:
            'https://www.google.com/url?sa=i&url=https%3A%2F%2Fpngtree.com%2Fso%2Fcompany-icon&psig=AOvVaw1_eAVbQrUURoadg9mX_Yhz&ust=1711682092269000&source=images&cd=vfe&opi=89978449&ved=0CBIQjRxqFwoTCPC2iOv-lYUDFQAAAAAdAAAAABAE',
          trashed: false,
          trashedAt: null,
          id: '646324b6f3a89fed15a2c228',
        },
        name: 'Deal 14',
        type: 'NEW_BUSINESS',
        closedAt: null,
        sequence: 1,
        createdAt: '2023-09-07T03:33:27.034Z',
        updatedAt: '2024-01-04T01:42:08.323Z',
        trashed: false,
        trashedAt: null,
        __v: 0,
        amount: 500,
        stageId: '64f94a605b1334b16062f3fd',
        _amount: '500.00',
      },
    ],
  },
};

export const stages = [
  {
    _id: '646448397996bbe2b288426b',
    pipelineId: '6464375a74df66748857a3d7',
    sequence: 1,
    name: 'Stage 1',
    actions: [],
    createdAt: '2023-05-17T03:21:29.839Z',
    updatedAt: '2023-05-30T03:09:28.106Z',
    trashed: false,
    trashedAt: null,
    __v: 0,
    id: '646448397996bbe2b288426b',
  },
  {
    _id: '646448467996bbe2b288427c',
    pipelineId: '6464375a74df66748857a3d7',
    sequence: 2,
    name: 'Stage 2',
    actions: [],
    createdAt: '2023-05-17T03:21:42.546Z',
    updatedAt: '2023-05-17T03:40:03.720Z',
    trashed: false,
    trashedAt: null,
    __v: 0,
    id: '646448467996bbe2b288427c',
  },
  {
    _id: '646441abd973766a4dd62f28',
    pipelineId: '6464375a74df66748857a3d7',
    sequence: 3,
    name: 'Stage 3',
    actions: [],
    createdAt: '2023-05-17T02:53:31.400Z',
    updatedAt: '2023-06-01T07:38:25.926Z',
    trashed: false,
    trashedAt: null,
    __v: 0,
    id: '646441abd973766a4dd62f28',
  },
  {
    _id: '64f94a605b1334b16062f3fd',
    pipelineId: '6464375a74df66748857a3d7',
    sequence: 4,
    name: 'Stage 4',
    actions: [],
    createdAt: '2023-09-07T03:58:24.578Z',
    updatedAt: '2023-09-07T03:58:24.578Z',
    trashed: false,
    trashedAt: null,
    __v: 0,
    id: '64f94a605b1334b16062f3fd',
  },
];

export const composerDealForm = {
  _id: '6603d732ec6060359d14cd1e',
  pipelineId: {
    _id: '6464375a74df66748857a3d7',
    accountId: '63e05fe4d59adc087e305e08',
    name: 'Pipeline 1',
    sequence: 1,
    isPrimary: true,
    createdAt: '2023-05-17T02:09:30.884Z',
    updatedAt: '2024-01-15T04:26:27.698Z',
    trashed: false,
    trashedAt: null,
    __v: 0,
    id: '6464375a74df66748857a3d7',
  },
  stageId: '646448397996bbe2b288426b',
  accountId: '63e05fe4d59adc087e305e08',
  accountUserId: [],
  leadId: [],
  companyId: {
    _id: '646324b6f3a89fed15a2c228',
    name: 'Deal 13',
    accountId: '63e05fe4d59adc087e305e08',
    industry: 'computer',
    type: 'corporation',
    city: 'San Francisco',
    state: 'CA',
    postalCode: '90210',
    noEmployees: 10100,
    annualRevenue: 32767,
    timezone: '',
    description: '',
    linkedinUrl: '',
    companyWebsite: 'www.microsoft.com',
    createdAt: '2023-05-16T06:37:42.128Z',
    updatedAt: '2024-01-23T08:34:49.748Z',
    __v: 0,
    photoUrl:
      'https://www.google.com/url?sa=i&url=https%3A%2F%2Fpngtree.com%2Fso%2Fcompany-icon&psig=AOvVaw1_eAVbQrUURoadg9mX_Yhz&ust=1711682092269000&source=images&cd=vfe&opi=89978449&ved=0CBIQjRxqFwoTCPC2iOv-lYUDFQAAAAAdAAAAABAE',
    trashed: false,
    trashedAt: null,
    id: '646324b6f3a89fed15a2c228',
  },
  name: 'Deal 2',
  type: 'NEW_BUSINESS',
  closedAt: null,
  amount: 2000,
  sequence: 1,
  createdAt: '2024-03-27T08:22:10.783Z',
  updatedAt: '2024-03-27T13:43:31.239Z',
  trashed: false,
  trashedAt: null,
  __v: 0,
};
